import { render, staticRenderFns } from "./r-item-order-dialog.vue?vue&type=template&id=79224234&scoped=true"
import script from "./r-item-order-dialog.vue?vue&type=script&lang=js"
export * from "./r-item-order-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-item-order-dialog.vue?vue&type=style&index=0&id=79224234&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79224234",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79224234')) {
      api.createRecord('79224234', component.options)
    } else {
      api.reload('79224234', component.options)
    }
    module.hot.accept("./r-item-order-dialog.vue?vue&type=template&id=79224234&scoped=true", function () {
      api.rerender('79224234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-order/r-item-order-dialog.vue"
export default component.exports